import { cx } from "@emotion/css";
import { memo, ReactElement, ReactNode } from "react";

import { BackArrowButton } from "@/modules/theme/components/BackArrowButton/BackArrowButton";
import { Typography } from "@/modules/theme/components/Typography/Typography";
import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createDetailLayoutStyles } from "./createDetailLayoutStyles";

export type DetailLayoutProps = {
  children: ReactNode;
  variant: "task" | "taskDone" | "tutorial";
  heading?: string | ReactElement;
  details?: ReactNode;
  onBackButtonClick?: () => void;
  containerClassName?: string;
};

export const DetailLayout = memo(
  ({
    children,
    variant,
    heading,
    details,
    onBackButtonClick,
    containerClassName,
  }: DetailLayoutProps) => {
    const classes = createDetailLayoutStyles(useTheme());

    return (
      <main className={cx(classes.root, classes[variant])}>
        <header className={classes.header}>
          <nav className={classes.arrowBack}>
            <BackArrowButton onClick={onBackButtonClick} />
          </nav>
          <Typography variant="heading">{heading}</Typography>
          <div className={classes.details}>{details}</div>
        </header>
        <div className={cx(classes.container, containerClassName)}>
          {children}
        </div>
      </main>
    );
  }
);
